import React from "react";
import { FaCog } from "react-icons/fa";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useFeatureFlags } from "../context/FeatureFlagsContext";
import { rememberReturnTo } from "../helpers/returnTo";

const ProtectedRoute = ({ element }) => {
  const { tokens, loading } = useAuth();
  const { loading: featuresLoading } = useFeatureFlags();
  const location = useLocation();

  if (loading || (tokens?.idToken && featuresLoading)) {
    return (
      <div className="protected-route-loading" role="status" aria-label="Loading">
        <FaCog className="spinner-cog" aria-hidden="true" />
      </div>
    );
  }

  if (!tokens?.idToken) {
    rememberReturnTo(location);
    return <Navigate to="/signin" replace />;
  }

  return element;
};

export default ProtectedRoute;
